export class ImagenModel {
    Id: number = 0;
    EmpresaId : number = 0;
    IncidenciaId : number = 0;
    Imagen : string = '';

    //agregado
    Nombre : string = '';
}